import { render, staticRenderFns } from "./AccountTabStatements.vue?vue&type=template&id=61ddd6c8&scoped=true"
import script from "./AccountTabStatements.vue?vue&type=script&lang=js"
export * from "./AccountTabStatements.vue?vue&type=script&lang=js"
import style0 from "./AccountTabStatements.vue?vue&type=style&index=0&id=61ddd6c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddd6c8",
  null
  
)

export default component.exports